import React__default from 'react';

/* istanbul ignore file */
const LayerSheetServerSideRender = ({
  onDismiss,
  className,
  children
}) => {
  const ref = React__default.useRef(null);
  const onKeyUp = React__default.useCallback(event => {
    if (event.key === 'Escape') {
      event.preventDefault();
      if (onDismiss && typeof onDismiss === 'function') {
        onDismiss();
      }
    }
  }, [onDismiss]);
  const onClick = React__default.useCallback(event => {
    if (event.target === ref.current && onDismiss && typeof onDismiss === 'function') {
      event.preventDefault();
      onDismiss();
    }
  }, [onDismiss]);
  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    React__default.createElement("div", {
      className: className,
      onKeyUp: onKeyUp,
      onClick: onClick,
      tabIndex: -1,
      ref: ref
    }, children)
  );
};
LayerSheetServerSideRender.displayName = 'LayerSheetServerSideRender';
export { LayerSheetServerSideRender };